<template>
    <div class="max-width-content">
        <breadcrumbs>
            <inertia-link href="/sitepages">Sitepaginas</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Nieuw sitepagina aanmaken
        </breadcrumbs>

        <div class="flex justify-between items-center">
            <div class="flex ">
                <h1 class="text-5xl text-teal-800 mr-1">Nieuw sitepagina aanmaken</h1>
            </div>
        </div>
        <div class="bg-white rounded-lg p-5">
            <site-page-form :categories="categories" @submit="submit"></site-page-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import SitePageForm from "@/admin/Pages/SitePages/SitePageForm";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";

export default {
    metaInfo() {
        return { title: "SitePage aanmaken" };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        Breadcrumbs,
        SitePageForm
    },

    props: {
        categories: Array
    },

    data() {
        return {};
    },

    methods: {
        submit(data) {
            this.loading = "submit";
            const url = this.route("admin.sitepages.store").url();

            const options = { onFinish: () => {
                this.loading = false;
                if (Object.keys(this.$page.props.errors).length === 0) {
                    this.form.image = null;
                }
            }}

            this.$inertia.post(url, data, options)
        }
    }
};
</script>
